<template>
    <div>
      <trademark-objection-to-us-case-decision-list></trademark-objection-to-us-case-decision-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  